import { render, staticRenderFns } from "./InputOnlyNumber2.vue?vue&type=template&id=494eb9bb&scoped=true"
import script from "./InputOnlyNumber2.vue?vue&type=script&lang=js"
export * from "./InputOnlyNumber2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494eb9bb",
  null
  
)

export default component.exports